import { isValidDate } from "../is/isValidDate.js";
import "markdown-it";
const getUTCTimeObject = (date) => {
  if (!isValidDate(date)) {
    throw new Error("[getUTCTimeObject] The value of the parameter 'date' does not match the Date format");
  }
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const isShow24hours = !hours && !minutes && !seconds;
  return {
    /**
     * Число 24 необходимо для случая, когда ДЦ работает до 00:00
     * Без этого, сравнивая текущее время с временем закрытия,
     * мы всегда будем получать "закрыто".
     */
    hours: isShow24hours ? 24 : hours,
    minutes,
    seconds
  };
};
export {
  getUTCTimeObject
};
